import { IGeographicalMapLocation } from "@components/shared/map/supply-chain-map.model";
import { ILocationLinkBase } from "@shared/interfaces";

export class GeographicalSupplyChainMap {
  constructor(
    public locations: IGeographicalMapLocation[],
    public links: ILocationLinkBase[],
  ) {}
}
